module.exports = __webpack_public_path__ + "assets/img/doc_developer.d5e32136.png";